











































import { Component, Vue } from 'vue-property-decorator';
import { SmartQuery } from 'vue-apollo-decorator';
import { GQL_currentUnit, GQL_currentUnit_currentUnit } from '@/queries/__generated__/currentUnit';
import { CURRENT_UNIT } from '@/queries/Application';
import { ALL_MUNICIPALITIES } from '@/queries/Municipality';
import { GQL_municipalitySelections_currentUnit_municipalitySelections, GQL_municipalitySelections } from '@/queries/__generated__/municipalitySelections';
import { GQL_municipalitySearch_municipalitySearch } from '@/queries/__generated__/municipalitySearch';
import { GQL_createMunicipalitySelectionVariables, GQL_createMunicipalitySelection } from '@/queries/__generated__/createMunicipalitySelection';
import { IRules } from '../UI/Form/ValidationModule';
import { validateRequired } from '../UI/Form/Validations';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { GQL_municipalities } from '@/queries/__generated__/municipalities';
import gql from 'graphql-tag';
import { MUNICIPALITY_SELECTIONS } from './municipalitySelections';

const MUNICIPALITY_SEARCH = gql`
  query municipalitySearch(
    $term: String!,
    $limit: Int,
    $offset: Int,
  ) {
    municipalitySearch(
      term: $term,
      limit: $limit,
      offset: $offset,
    ) {
      id
      number
      name
    }
  },
`;

const CREATE_MUNICIPALITY_SELECTION = gql`
  mutation createMunicipalitySelection($municipalityId: ID!, $unitId: ID!) {
    createMunicipalitySelection(input: { municipalityId: $municipalityId, unitId: $unitId }) {
      municipalitySelection {
        id
        municipality {
          id
          number
          name
          bban
          organizationNumber
          organizationName
          organizationForm
          comment
          webpage
          email
          telephone
          mobile
          telefax
          address1
          address2
          address3
          zip
          city
          countyName
          employerTaxZone {
            id
            rate
            code
          }
        }
      }
    }
  },
`;

@Component
export default class MunicipalitySelectionForm extends Vue {
  @SmartQuery<MunicipalitySelectionForm, GQL_currentUnit>({
    query: CURRENT_UNIT,
    result({ data }) {
      this.municipalitySelectionVariables.unitId = data.currentUnit.id;
    },
  }) private currentUnit!: GQL_currentUnit_currentUnit;

  @SmartQuery<MunicipalitySelectionForm, GQL_municipalitySelections>({
    query: MUNICIPALITY_SELECTIONS,
    update: data => data.currentUnit.municipalitySelections,
  }) private municipalitySelections!: GQL_municipalitySelections_currentUnit_municipalitySelections[];

  private CREATE_MUNICIPALITY_SELECTION = CREATE_MUNICIPALITY_SELECTION;
  private MUNICIPALITY_SEARCH = MUNICIPALITY_SEARCH;

  private municipalitySelectionVariables: GQL_createMunicipalitySelectionVariables = {
    municipalityId: '',
    unitId: '',
  };

  private validForm = false;

  private rules: IRules = {
    municipalityId: [
      {
        validation: validateRequired(),
        message: i18n => i18n.t('Error.required', { field: i18n.t('Municipality.municipality') }),
      },
      {
        validation: ({ dataValue }) => !this.municipalitySelections.map(m => m.municipality.id).includes(dataValue),
        message: i18n => i18n.t('Error.alreadyTaken', { field: i18n.t('Municipality.municipality') }),
      },
    ],
  };

  private selectMunicipality(municipality: GQL_municipalitySearch_municipalitySearch) {
    this.municipalitySelectionVariables.municipalityId = municipality.id;
  }

  private addToCache(store: InMemoryCache, query: {data: GQL_createMunicipalitySelection }) {
    const data = (store.readQuery({ query: MUNICIPALITY_SELECTIONS }) as GQL_municipalitySelections);
    if (!data || !query.data.createMunicipalitySelection?.municipalitySelection) return;
    const municipality = query.data.createMunicipalitySelection!.municipalitySelection!;
    data.currentUnit.municipalitySelections.push(municipality);
    store.writeQuery({ query: MUNICIPALITY_SELECTIONS, data });

    try {
      const allMunicipalities = (store.readQuery({ query: ALL_MUNICIPALITIES }) as GQL_municipalities);
      allMunicipalities.currentUnit.municipalities.push(municipality.municipality);
    } catch (e) {}

    return municipality;
  }

  private municipalitySelectionCreated() {
    this.municipalitySelectionVariables.municipalityId = '';
    this.$sMessage.success(this.$t('Municipality.AddMunicipalities.success'));
  }
}
